// VoiceSpectrum.Web.T2 · v12.10.9 (Security Phase 1 – #1255/#1256/#1257) · 2026-10-06
// LoginPage - the three public sign-in routes. Every state (L1–L13 of Login_Prototype_v1_2) lives in
// pages/login/SignInFlow.tsx; this file only picks the entry point:
//   /login            → sign in (and every step after it)
//   /reset-password   → ?token= from the reset email → L7 new password
//   /invite           → ?token= from the invite email/text → L10 accept invite / L11 expired
// Replaces the v12.10.7.1 page (email + password + old TOTP step). The design is the same: left brand panel, right card.
import SignInFlow from './login/SignInFlow';

export default function LoginPage() {
  return <SignInFlow mode="login" />;
}

export function ResetPasswordPage() {
  return <SignInFlow mode="reset" />;
}

export function InvitePage() {
  return <SignInFlow mode="invite" />;
}
